// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__nlASx","AboutButton":"App_AboutButton__mZfzw"};